import account from './../../store/modules/account/index';
import { AllowValue } from './../../const/allowList';
import { updateWhiteValues } from './../../service/index';

const useWhiteListHooks = () => {
  const entryWhitelist = async () => {
    // 282 223 344 开白
    const addWhitelist = [];
    // 若已有 native 开白，则添加 engagement
    !account.state.accountInfo.white_value?.includes(AllowValue.native) && addWhitelist.push(AllowValue.native);
    !account.state.accountInfo.white_value?.includes(AllowValue.engagement) && addWhitelist.push(AllowValue.engagement);
    !account.state.accountInfo.white_value?.includes(AllowValue.lowest_budget) &&
      addWhitelist.push(AllowValue.lowest_budget);
    // send the request
    if (addWhitelist.length > 0) {
      await updateWhiteValues(addWhitelist);
    }
  };
  return {
    entryWhitelist,
  };
};
export { useWhiteListHooks };
